module.exports = __webpack_public_path__ + "img/kf.4b63e00c.png";